<template>
  <div class="hidden md:flex flex-row pb-5">
    <div class="flex items-center cursor-pointer" @click="backToDashboard">
      <div class="flex items-center">
        <ChevronLeftIcon class="w-5 h-5 text-brand-green" />
      </div>
      <div class="flex items-center">
        <p class="text-brand-dark-gray text-sm">Back to forms</p>
      </div>
    </div>
  </div>
  <template v-if="getCurrentApplicationTemplate">
    <!-- START DESKTOP Form Settings/Editor NAV -->
    <div class="hidden md:flex flex-col rounded-lg shadow-sm bg-white px-5 py-5 max-w-screen-xl">
      <div class="flex flex-row justify-between">
        <div class="flex items-center">
          <h5 class="text-brand-black text-lg">
            {{ getCurrentApplicationTemplate.name }}
          </h5>
          <p class="text-brand-mid-gray text-sm mx-3 truncate max-w-xs">
            {{ origin }}/apply/{{ getCurrentApplicationTemplate.slug }}
          </p>
          <CopyLinkIcon :url="`${origin}/apply/${getCurrentApplicationTemplate.slug}`" />
        </div>
        <div class="flex flex-row items-center">
          <TrashIcon
            v-if="getCurrentApplicationTemplate && getCurrentApplicationTemplate.can_edit"
            class="text-brand-red w-6 h-6 mr-2 cursor-pointer"
            @click="toggleDeleteFormModal"
          />
          <router-link
            :to="{
              name: 'dashboard_form_settings',
              params: { slug: $route.params.slug }
            }"
          >
            <button
              class="w-36 py-2 px-2 mx-2 rounded-lg focus:outline-none text-base"
              :class="[
                $route.name === 'dashboard_form_settings'
                  ? 'text-brand-green border-2 border-brand-background-light-green bg-brand-background-light-green'
                  : 'text-brand-black border-2 border-brand-mid-gray bg-white'
              ]"
            >
              Form Settings
            </button>
          </router-link>

          <router-link
            :to="{
              name: 'dashboard_form_edit',
              params: { slug: $route.params.slug }
            }"
          >
            <button
              class="w-36 py-1 md:py-2 px-2 mx-2 rounded-lg focus:outline-none text-base"
              :class="[
                $route.name === 'dashboard_form_edit'
                  ? 'text-brand-green border-2 border-brand-background-light-green bg-brand-background-light-green'
                  : 'text-brand-black border-2 border-brand-mid-gray bg-white'
              ]"
            >
              Form Editor
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <!-- END DESKTOP Form Settings/Editor NAV -->

    <div class="md:py-5 flex max-w-screen-xl">
      <router-view />
    </div>
  </template>
  <DeleteFormModal :showModal="showDeleteFormModal" @close="toggleDeleteFormModal" />
</template>
<script>
import { mapGetters } from "vuex"
import { ChevronLeftIcon, TrashIcon } from "@heroicons/vue/outline"

import { APPLICATION_TEMPLATE_GET } from "@/store/types"

import DeleteFormModal from "./components/DeleteFormModal.vue"

export default {
  components: {
    ChevronLeftIcon,
    TrashIcon,
    DeleteFormModal
  },
  computed: {
    ...mapGetters(["isApplicationTemplateLoading", "getCurrentApplicationTemplate"]),
    origin() {
      return location.origin
    }
  },
  data() {
    return {
      showDeleteFormModal: false
    }
  },
  async mounted() {
    const slug = this.$route.params.slug
    if (!this.getCurrentApplicationTemplate || this.getCurrentApplicationTemplate.slug !== slug) {
      await this.$store.dispatch(APPLICATION_TEMPLATE_GET, { slug })
    }
  },
  methods: {
    backToDashboard() {
      this.$router.push({
        name: "dashboard_forms"
      })
    },
    toggleDeleteFormModal() {
      this.showDeleteFormModal = !this.showDeleteFormModal
    }
  }
}
</script>
